import safeFetch from '../../utils/safeFetch';

const addItemToUrl = (url, requestData) => {
  return new Promise((resolve, reject) => {
    safeFetch(url, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    })
      .then(async (response) => {
        if (!response.ok) {
          const text = await response.text().catch(() => '');
          throw new Error(`HTTP error! status: ${response.status}, body: ${text}`);
        }
        let data;
        try {
          data = await response.json();
        } catch (err) {
          const raw = await response
            .clone()
            .text()
            .catch(() => '');
          console.error(err);
          throw new Error(`Server Response invalid. Not a valid JSON! Body: ${raw}`);
        }
        return data;
      })
      .then((data) => {
        if (typeof data !== 'object' || data === null) {
          return reject(
            new Error(`Invalid Response: not a valid JSON-Object. Value: ${JSON.stringify(data)}`),
          );
        }
        if (typeof data.success !== 'boolean') {
          return reject(
            new Error(
              `Invalid API-Response: "success" missing or not a boolean. Response: ${JSON.stringify(data)}`,
            ),
          );
        }
        if (data.success === false) {
          const message = data.error || data.message || 'Unknown error from the server.';

          const err = new Error(message);
          err.data = data;
          return reject(err);
        }
        resolve({ data });
      })
      .catch((error) => reject(error));
  });
};

export default addItemToUrl;
